export class AccountPermissions {
    public permissionList:Array<string>;
    public ONECLICK_ENV:string;

    constructor(data:Array<string>|void) {
        if(data === undefined)
        {
            this.permissionList = [];
            this.ONECLICK_ENV = import.meta.env.VITE_ONECLICK_ENV;
        }
        else
        {
            this.permissionList = data;
            this.ONECLICK_ENV = import.meta.env.VITE_ONECLICK_ENV;
        }
    }

    allowedAny(permissions:Array<string>):boolean
    {
      if (this.ONECLICK_ENV === 'olga' || this.ONECLICK_ENV === 'stelian' || this.ONECLICK_ENV === 'ionut' || this.ONECLICK_ENV === 'andrei') {
            return true;
        }

        for(let i = 0; i < permissions.length; i++)
        {
            if(permissions[i].trim() === "")
            {
                continue;
            }

            if(this.permissionList.findIndex(permission => permission == permissions[i]) >= 0)
            {
                return true;
            }
        }

        return false;
    }

    allowedAll(permissions:Array<string>):boolean
    {
      if (this.ONECLICK_ENV === 'olga' || this.ONECLICK_ENV === 'stelian' || this.ONECLICK_ENV === 'ionut' || this.ONECLICK_ENV === 'andrei') {
            return true;
        }

        for(let i = 0; i < permissions.length; i++)
        {
            if(permissions[i].trim() === "")
            {
                continue;
            }

            if(this.permissionList.findIndex(permission => permission == permissions[i]) === -1)
            {
                return false;
            }
        }

        return true;
    }

}
